module.exports = __webpack_public_path__ + "fonts/roboto-condensed-v19-latin-ext_latin-regular.8d8e0ed.ttf";